export default __webpack_public_path__ + "static/media/brighter-redact-dark-blue.de49f940.svg";